export function isValidAuMobile(value: string): boolean {
  const digits = value.replace(/\D/g, '')
  return /^04\d{8}$/.test(digits) || /^614\d{8}$/.test(digits)
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const result = String(reader.result ?? '')
      const comma = result.indexOf(',')
      resolve(comma >= 0 ? result.slice(comma + 1) : result)
    }
    reader.onerror = () => reject(reader.error ?? new Error('Failed to read file'))
    reader.readAsDataURL(file)
  })
}

export function formatDate(value?: string | null): string {
  if (!value) return '—'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return value.slice(0, 10)
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
}

export function formatDateTime(value?: string | null): string {
  if (!value) return '—'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return value
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatCase(code: string): string {
  if (!code) return '—'
  return code.startsWith('FFC-') ? code : `FFC-${code}`
}

export function fullName(first?: string | null, last?: string | null): string {
  return [first, last].filter(Boolean).join(' ') || '—'
}

export function statusTone(status?: string | null): 'brand' | 'success' | 'warning' | 'danger' | 'neutral' {
  if (!status) return 'neutral'
  const s = status.toLowerCase()
  if (
    s.includes('cancel') ||
    s.includes('noshow') ||
    s.includes('no-show') ||
    s.includes('reject') ||
    s.includes('closed') ||
    s.includes('extreme') ||
    s.includes('high') ||
    s.includes('fail') ||
    s.includes('error')
  )
    return 'danger'
  if (s.includes('skip')) return 'warning'
  if (s.includes('active') || s.includes('approved') || s.includes('completed') || s.includes('signed') || s.includes('confirmed') || s === 'sent')
    return 'success'
  if (s.includes('pending') || s.includes('submission') || s.includes('meeting') || s.includes('review') || s.includes('draft') || s.includes('reschedul')) return 'warning'
  return 'brand'
}

export function errorMessage(err: unknown, fallback = 'Something went wrong'): string {
  if (err instanceof Error && err.message) return err.message
  return fallback
}

export function initialsFromName(name?: string | null): string {
  if (!name?.trim()) return 'U'
  const parts = name.trim().split(/[\s._@-]+/).filter(Boolean)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
}
